@use '../../style/theme.scss';
@use '../../style/rest.scss';

:host {
  @include rest.rest;

  display: block;
  width: 100%;
}

.stripe-currency-selector-wrap {
  width: 100%;
  padding: 0;
  margin: 0;

  #currency-selector {
    width: 100%;
    min-height: 40px;
  }

  #currency-selector-errors {
    margin-top: 8px;
  }
}
